import type { FaireProductEntity } from "../../entity_types/product";

export const p_ykdb6en39f: FaireProductEntity = {
  token: "p_ykdb6en39f",
  type: "product",
  name: "Como Pinch Bowl /Incense Holder/Trinket Bowl (Ships from Uk)",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl: "https://cdn.faire.com/fastly/4870190211520b884f752c2d6d7bf2f207c7951d07f6875239d3cb24e2c71bde.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cefff7df6dd2b10f250b3f9d07e1590ade6ab8471c46e6254c59aac4d006ae91.jpeg",
    "https://cdn.faire.com/fastly/a8aa1d9974d5f87668158fb621652fb814883c3429cd39db51dff99887d2cc98.jpeg",
    "https://cdn.faire.com/fastly/df7531d9b22d499637c17d7fbc8e0d011751cc33cf064599fdfc22c66c0ef8d2.jpeg"
  ],
  priceDollars: 13.44,
  description: "PLEASE NOTE THAT THIS ITEM WILL BE SHIPPING FROM OUR UK WAREHOUSE\n\nCOMO pinch bowl is a versatile object that can be used at your dinner table, desk or bedside table. Use it to serve salt or pepper, store jewellery or light an incense cone.  Each COMO bowl is handcrafted from a solid piece of beautiful marble with a sophisticated honed matte finish. \n\nProduct information\n\nPlease note that due to the nature of the material, colour and pattern variation will occur. Giving you a truly unique piece. Our photos should be used as a guide.\n\nDimensions: H35 x D70mm\nMaterial: Marble",
  tags: [],
  msrpDollars: 32,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:17.846Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
